/**
 * @fileoverview Hook UI Layer para gestión visual y handlers de CustomerReminderMC.
 * @module useCustomerRemindersUI
 * @category Hook - UI Layer
 * @since 1.0.0
 * @version 1.1.0
 */
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SIDEBAR_ACTIONS } from '../../../../constants/actionsConstants';

/**
 * @typedef {Object} UseCustomerRemindersUIResult
 * @property {function} openDealModal - Handler para abrir el modal de programación
 */

/**
 * Hook UI Layer para gestión visual y handlers de CustomerReminderMC.
 *
 * - Solo gestiona estado visual y handlers UI.
 * - Optimizado con useCallback y separación estricta de responsabilidades.
 *
 * @param {Object} customer - Objeto customer para el modal
 * @returns {UseCustomerRemindersUIResult}
 * @see {@link useCustomerRemindersData} Para carga de datos
 */
export default function useCustomerRemindersUI(customer) {
  const dispatch = useDispatch();
  const openDealModal = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'NewChat',
        props: {
          hasCustomer: true,
          type: 'reminder'
        },
      },
    });
  }, [dispatch, customer]);
  return { openDealModal };
}
